import { AdminServices } from '@/services/admin.services'

const state = {
  loading: true,
  dialog: false,
  overlay: false,
  dialogtrfdana: false,
  cashin: [],
  totalcashin: 0,
  cashout: [],
  cashout_download: [],
  cashin_download: [],
  totalcashout: 0,
  account: [],
  accounthistories: [],
  totalaccounthistori: 0,
  monitoringsaldo: {
    saldoakun: 0,
    saldomember: 0,
    pending: 0,
    cashout: 0
  },
  sumcashin: {
    jml: 19,
    amount: 1000000,
    pending: 10
  },
  sumcashout: {
    jml: 10,
    amount: 9000000,
    pending: 10
  }
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  setdialogtrfdana ({ commit }, diag) {
    commit('setdialogtrfdana', diag)
  },
  trfdanaAntarkas ({ dispatch, commit }, data) {
    commit('setloading', true)
    AdminServices.trfdanaantaskas(data).then(value => {
      commit('setloading', false)
      commit('setdialogtrfdana', false)
      dispatch('alert/success', 'Transfer Dana Ok!', { root: true })
      dispatch('getAccount')
      dispatch('getMonitoringsaldo')
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getMonitoringsaldo ({ commit }) {
    commit('setloading', true)
    AdminServices.getAccountMonitoring().then(value => {
      commit('setloading', false)
      commit('setmonitoringsaldo', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getSumcashin ({ commit }, opt) {
    commit('setloading', true)
    AdminServices.getSumCashin(opt).then(value => {
      commit('setloading', false)
      commit('setsumcashin', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getSumcashOut ({ commit }, opt) {
    commit('setloading', true)
    AdminServices.getSumCashOut(opt).then(value => {
      commit('setloading', false)
      commit('setsumcashout', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getAccount ({ commit }) {
    commit('setloading', true)
    AdminServices.getAccounts().then(value => {
      commit('setloading', false)
      commit('setaccount', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getCashIn ({ commit }, opt) {
    commit('setloading', true)
    localStorage.setItem('getCashInFilter', JSON.stringify(opt))
    AdminServices.getCashIn(opt).then(value => {
      commit('setloading', false)
      commit('setdatacashin', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getCashOut ({ commit }, opt) {
    commit('setloading', true)
    localStorage.setItem('getCashOutFilter', JSON.stringify(opt))
    AdminServices.getCashOut(opt).then(value => {
      commit('setloading', false)
      commit('setdatacashout', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getCashInDownload ({ commit }, opt) {
    commit('setloading', true)
    AdminServices.getCashInDownload(opt).then(value => {
      commit('setloading', false)
      commit('setdatacashindownload', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getCashOutDownload ({ commit }, opt) {
    commit('setloading', true)
    AdminServices.getCashOutDownload(opt).then(value => {
      commit('setloading', false)
      commit('setdatacashoutdownload', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  approveCashIN ({ dispatch, commit }, opt) {
    commit('setloading', true)
    AdminServices.approveCashIN(opt).then(value => {
      commit('setloading', false)
      dispatch('alert/success', 'Approve Ok!', { root: true })
      var a = JSON.parse(localStorage.getItem('getCashInFilter'))
      AdminServices.getCashIn(a).then(value => {
        commit('setloading', false)
        commit('setdatacashin', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
      })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  prosesCashOUT ({ dispatch, commit }, opt) {
    commit('setloading', true)
    AdminServices.updateCashout(opt).then(value => {
      commit('setloading', false)
      dispatch('alert/success', 'Approve Ok!', { root: true })
      var a = JSON.parse(localStorage.getItem('getCashOutFilter'))
      AdminServices.getCashOut(a).then(value => {
        commit('setloading', false)
        commit('setdatacashout', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
      })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  approveCashOUT ({ dispatch, commit }, opt) {
    commit('setloading', true)
    AdminServices.approveCashOUT(opt).then(value => {
      commit('setloading', false)
      dispatch('alert/success', 'Approve Ok!', { root: true })
      var a = JSON.parse(localStorage.getItem('getCashOutFilter'))
      AdminServices.getCashOut(a).then(value => {
        commit('setloading', false)
        commit('setdatacashout', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
      })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  rejectCashin ({ dispatch, commit }, opt) {
    commit('setloading', true)
    AdminServices.rejectCashIn(opt).then(value => {
      commit('setloading', false)
      dispatch('alert/success', 'Reject Ok!', { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdialogtrfdana (state, s) {
    state.dialogtrfdana = s
  },
  setdatacashin (state, s) {
    state.cashin = []
    state.cashin = s.data.content
    state.totalcashin = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setdatacashout (state, s) {
    state.cashout = []
    state.cashout = s.data.content
    state.totalcashout = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setdatacashoutdownload (state, s) {
    state.cashout_download = []
    state.cashout_download = s.data
    state.loading = false
    state.overlay = false
  },
  setdatacashindownload (state, s) {
    state.cashin_download = []
    state.cashin_download = s.data
    state.loading = false
    state.overlay = false
  },
  setaccount (state, s) {
    state.account = []
    state.account = s.data
    state.loading = false
    state.overlay = false
  },
  setmonitoringsaldo (state, s) {
    state.monitoringsaldo = s.data
    state.loading = false
    state.overlay = false
  },
  setsumcashin (state, s) {
    state.sumcashin = s.data
    state.loading = false
    state.overlay = false
  },
  setsumcashout (state, s) {
    state.sumcashout = s.data
    state.loading = false
    state.overlay = false
  }
}

export const AdmStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
